var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4142 21.5858C11.6332 20.8047 10.3668 20.8047 9.58579 21.5858C8.80474 22.3668 8.80474 23.6332 9.58579 24.4142L18.5858 33.4142C19.3668 34.1953 20.6332 34.1953 21.4142 33.4142L38.4142 16.4142C39.1953 15.6332 39.1953 14.3668 38.4142 13.5858C37.6332 12.8047 36.3668 12.8047 35.5858 13.5858L20 29.1716L12.4142 21.5858Z",
    fill: "#00A300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b391b3b5893f9fff62fb11e5217583aa.svg";
export { ForwardRef as ReactComponent };